import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";

export const ElBanner = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  background-color: transparent;
  background: linear-gradient(180deg, #e9f5ff 700%, rgba(229, 239, 255, 0.26) 83.7%, rgba(229, 239, 255, 0) 700%);
  ${isMobile} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  ${isMobile} {
    flex-direction: column;
  }
`;

export const ElColumn = styled.div`
  max-width: 50%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  gap: 20px;
  position: relative;
  ${isMobile} {
    max-width: 100%;
    flex: none;
  }
`;

export const ElHeadLine = styled.h1`
  display: flex;
  text-align: left;
  width: 100%;
  /* width: max-content; */
  font-size: 36px;
  font-weight: 600;
  color: var(--theme-main-flat-dark-color);
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  background-color: transparent;
  /* background-image: linear-gradient(45deg, #10575c 0%, #297b10 100%); */
`;

export const ElDetails = styled.p`
  width: 100%;
  text-align: left;
  font-size: 17px;
  font-weight: 400;
  color: var(--theme-main-flat-dark-color);
  line-height: 1.6em;

  strong {
    font-weight: 700;
  }
`;

export const ElProgramTitle = styled.h3`
  text-align: left;
  font-size: 23px;
  font-weight: 600;
  opacity: 0.6;
`;

export const ElpoweredImage = styled.img`
  max-width: 300px;
  width: 100%;
  margin: auto;
  position: relative;
  z-index: 2;
`;

export const ElCircleImg = styled.img`
  /* max-width: 300px; */
  width: 85%;
  margin: auto;
  position: absolute;
  bottom: -50%;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 1;
`;

export const elGapBanner = css`
  gap: 20px;
`;
